export default __webpack_public_path__ + "static/Entenda0037-38a3c4420942cb210852fb13195824c4.jpg";